import React from 'react';
import {observer} from 'mobx-react';
import {Route, Switch} from 'react-router-dom';
import DetailView from './DetailView';
import UnwatchedView from './UnwatchedView';
import {recentlyMediaStore, unwatchedMediaStore} from "../../store/MediaStore";
import RecentlyView from "./RecentlyView";
import CommonHelper from "../../helper/CommonHelper";
import qs from "qs";

const store = recentlyMediaStore;

@observer
class RecentlyViewFrame extends React.Component {

    componentDidMount() {
        let {location} = this.props;
        store.searchCondition.replace(CommonHelper.objectToMap(qs.parse(this.props.location.search, { ignoreQueryPrefix: true })));
        store.debounceFetch(true);
    }


    componentWillUnmount() {
        store.clear()
    }

    render() {
        return (
            <Switch>
                <Route path="/main/recently/:folderId/:fileId" component={DetailView}/>
                <Route path="/main/recently" component={RecentlyView}/>
            </Switch>
        );

    }
}

export default RecentlyViewFrame;
